import { NormalBrowseFileInputFiled, NormalTextInputField } from "@/components";
import React, { useMemo } from "react";

const StartYourBusinessRegisterProcessSection = ({
  activeLang,
  isFetching,
  allFilesResponse,
  searchValue,
  selectedFileType,
  onChangeImage,
  handleTextInputChange,
  stateDetails,
  adminRole,
  permissionsList,
}) => {
  const isNonTranslatableField = useMemo(() => {
    return activeLang === "en" ? true : false;
  }, [activeLang]);

  const getSelectedInfoImageId = (id) => {
    if (id) {
      onChangeImage(
        "start-your-business-section-5-register-process-logo-image",
        id
      );
    } else {
      onChangeImage(
        "start-your-business-section-5-register-process-logo-image",
        ""
      );
    }
  };

  return (
    <>
      {/* Logo */}
      {isNonTranslatableField && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          labelText="Logo"
          fieldId="start-your-business-section-5-register-process-logo-image"
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={getSelectedInfoImageId}
          selectedFileId={
            stateDetails?.[
              "start-your-business-section-5-register-process-logo-image"
            ] || ""
          }
          adminRole={adminRole}
          permissionsList={permissionsList}
          extraContainerClasses="mb-5"
        />
      )}

      {/* Title */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Title"
        fieldId="start-your-business-section-5-register-process-title"
        fieldName="start-your-business-section-5-register-process-title"
        placeholderText="Title"
        inputValue={
          stateDetails?.[
            "start-your-business-section-5-register-process-title"
          ] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />

      {/* Description */}
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Description"
        fieldId="start-your-business-section-5-register-process-description"
        fieldName="start-your-business-section-5-register-process-description"
        placeholderText="Description"
        inputValue={
          stateDetails?.[
            "start-your-business-section-5-register-process-description"
          ] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />

      {/* Button Label */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Button Label"
        fieldId="start-your-business-section-5-register-process-button-label"
        fieldName="start-your-business-section-5-register-process-button-label"
        placeholderText="Button Label"
        inputValue={
          stateDetails?.[
            "start-your-business-section-5-register-process-button-label"
          ] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />
    </>
  );
};

export default StartYourBusinessRegisterProcessSection;
